export default __webpack_public_path__ + "static/media/dropdown.9f8b088f.svg";